import { SimpleCountry } from "@daytrip/legacy-models";
import { UBO } from "@daytrip/legacy-models";
import { isNotUndefinedOrNull } from "@daytrip/utils";
import autobind from "autobind-decorator";
import { action, computed, observable } from "mobx";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface UBOOperatorOptions extends ModelOperatorOptions<UBO, {}, UBOOperatorData> {}

interface UBOOperatorData {
    simpleCountries: Array<SimpleCountry>;
}

interface UBOOperatorDataFetched extends UBOOperatorData {
    simpleCountries: Array<SimpleCountry>;
}

@autobind
export class UBOOperator extends ModelOperator<UBO, UBOOperatorOptions, {}, UBOOperatorData, UBOOperatorDataFetched> {
    @observable
    public birthAtDay: number;

    @observable
    public birthAtMonth: number;

    @observable
    public birthAtYear: number;

    @action
    public updateBirthAtDay(value: number) {
        this.birthAtDay = value;
        const model = this.m;
        if (isNotUndefinedOrNull(model.birthdayAt)) {
            const date = new Date(model.birthdayAt);
            this.birthAtMonth = date.getUTCMonth();
            this.birthAtYear = date.getUTCFullYear();
        }
        if (
            isNotUndefinedOrNull(this.birthAtDay) &&
            isNotUndefinedOrNull(this.birthAtMonth) &&
            isNotUndefinedOrNull(this.birthAtYear)
        ) {
            this.updateBirthAt(this.birthAtDay, this.birthAtMonth, this.birthAtYear);
        }
    }

    @action.bound
    public updateBirthAtMonth(value: number) {
        this.birthAtMonth = value;
        const model = this.m;
        if (isNotUndefinedOrNull(model.birthdayAt)) {
            const date = new Date(model.birthdayAt);
            this.birthAtDay = date.getUTCDate();
            this.birthAtYear = date.getUTCFullYear();
        }
        if (
            isNotUndefinedOrNull(this.birthAtDay) &&
            isNotUndefinedOrNull(this.birthAtMonth) &&
            isNotUndefinedOrNull(this.birthAtYear)
        ) {
            this.updateBirthAt(this.birthAtDay, this.birthAtMonth, this.birthAtYear);
        }
    }

    @action.bound
    public updateBirthAtYear(value: number) {
        this.birthAtYear = value;
        const model = this.m;
        if (isNotUndefinedOrNull(model.birthdayAt)) {
            const date = new Date(model.birthdayAt);
            this.birthAtDay = date.getUTCDate();
            this.birthAtMonth = date.getUTCMonth();
        }
        if (
            isNotUndefinedOrNull(this.birthAtDay) &&
            isNotUndefinedOrNull(this.birthAtMonth) &&
            isNotUndefinedOrNull(this.birthAtYear)
        ) {
            this.updateBirthAt(this.birthAtDay, this.birthAtMonth, this.birthAtYear);
        }
    }

    @action.bound
    public updateBirthAt(day: number, month: number, year: number) {
        const date: Date = new Date(year, month, day, 9);
        if (isNotUndefinedOrNull(date)) {
            this.m.birthdayAt = date;
        }
    }

    @computed
    public get nationality(): string {
        const nationality = this.data.simpleCountries.find((sc) => sc.isoCode == this.m.nationalityCountryISOCode);
        return isNotUndefinedOrNull(nationality) ? nationality.englishName : "";
    }

    @computed
    public get addressCountry(): string {
        const addressCountry = this.data.simpleCountries.find((sc) => sc.isoCode == this.m.address.countryISOCode);
        return isNotUndefinedOrNull(addressCountry) ? addressCountry.englishName : "";
    }

    @computed
    public get birthplaceCountry(): string {
        const birthplaceCountry = this.data.simpleCountries.find((sc) => sc.isoCode == this.m.birtplace.countryISOCode);
        return isNotUndefinedOrNull(birthplaceCountry) ? birthplaceCountry.englishName : "";
    }
}
